import React, { Component } from 'react';

class Contactus extends Component {
    render() {
        const addressLines = [
            'Nature Way Agro Foods',
            '& Cosmetics',
            'No 4, Elims Nagar,',
            'Vedanayagam Road Pazhanjur,',
            'Pappanchatiram,',
            'Chennai - 600123',
        ];

        const contactCards = [
            {
                icon: 'fa-map-marker',
                title: 'Visit Us',
                content: addressLines,
            },
            {
                icon: 'fa-phone',
                title: 'Call Us',
                content: [
                    { label: 'Customer Care', value: '+91 44 1234 5678' },
                    { label: 'Sales Enquiries', value: '+91 44 9876 5432' },
                ],
            },
            {
                icon: 'fa-envelope-o',
                title: 'Email Us',
                content: [
                    { label: 'General Enquiries', value: 'info@naturewaymart.com', href: 'mailto:info@naturewaymart.com' },
                    { label: 'Support', value: 'support@naturewaymart.com', href: 'mailto:support@naturewaymart.com' },
                    { label: 'Business Partnerships', value: 'partnership@natureway.com', href: 'mailto:partnership@natureway.com' },
                ],
            },
            {
                icon: 'fa-clock-o',
                title: 'Working Hours',
                content: [
                    { label: 'Monday - Saturday', value: '9:00 AM - 6:00 PM' },
                ],
            },
        ];

        const productOptions = [
            'Cold Pressed Oils',
            'Cosmetics',
            'Natural Ingredients',
            'Wholesale Orders',
        ];

        const partnerCategories = [
            { iconClass: 'icon-store', label: 'Retail Stores' },
            { iconClass: 'icon-cart', label: 'Supermarkets' },
            { iconClass: 'icon-leaf', label: 'Organic Stores' },
            { iconClass: 'icon-briefcase', label: 'Distributors' },
            { iconClass: 'icon-dinner', label: 'Hotels & Restaurants' },
            { iconClass: 'icon-truck', label: 'Export Partners' },
            { iconClass: 'icon-users', label: 'Business Partners' },
            { iconClass: 'icon-truck', label: 'Bulk Suppliers' },
        ];

        const contactEmails = [
            {
                icon: 'icon-envelope',
                value: 'info@naturewaymart.com',
                href: 'mailto:info@naturewaymart.com',
            },
            {
                icon: 'icon-headphones',
                value: 'suport@naturewaymart.com',
                href: 'mailto:suport@naturewaymart.com',
            },
        ];

        const mapLink = 'https://www.google.com/maps?ll=13.029886,80.034694&z=16&t=m&hl=en-IN&gl=US&mapclient=embed&cid=13920011168267437255';

        return (
            <div className="ps-contact-page">
                <section className="ps-contact-page__banner" aria-label="Contact page banner">
                    <img
                        className="ps-contact-page__banner-image"
                        src="/assets/img/contact/contact_banner.png"
                        alt="Contact us banner"
                    />
                </section>

                <section className="ps-contact-page__info" aria-label="Contact information">
                    <div className="ps-contact-page__shell">
                        <div className="ps-contact-page__info-grid">
                            {contactCards.map((card) => (
                                <article className="ps-contact-page__info-card" key={card.title}>
                                    <div className="ps-contact-page__info-header">
                                        <span className="ps-contact-page__info-icon" aria-hidden="true">
                                            <i className={`fa ${card.icon}`} />
                                        </span>
                                        <h2 className="ps-contact-page__info-title">{card.title}</h2>
                                    </div>

                                    <div className="ps-contact-page__info-divider" aria-hidden="true">
                                        <img
                                            className="ps-contact-page__info-divider-image"
                                            src="/assets/img/about/about-line.png"
                                            alt=""
                                            aria-hidden="true"
                                        />
                                    </div>

                                    <div className="ps-contact-page__info-body">
                                        {card.content.map((item) => (
                                            <div className="ps-contact-page__info-item" key={typeof item === 'string' ? item : item.label}>
                                                {typeof item === 'string' ? (
                                                    <p>{item}</p>
                                                ) : (
                                                    <>
                                                        <h3>{item.label}</h3>
                                                        {item.href ? (
                                                            <a href={item.href}>{item.value}</a>
                                                        ) : (
                                                            <p>{item.value}</p>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        ))}
                                    </div>
                                </article>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="ps-contact-page__contact-panels" aria-label="Contact form and partnerships">
                    <div className="ps-contact-page__shell">
                        <div className="ps-contact-page__contact-grid">
                            <div className="ps-contact-page__panel ps-contact-page__panel--form">
                                <div className="ps-contact-page__panel-heading">
                                    <h2 className="ps-contact-page__panel-title">Send Us a Message</h2>
                                    <img
                                        className="ps-contact-page__panel-divider"
                                        src="/assets/img/about/about-line.png"
                                        alt=""
                                        aria-hidden="true"
                                    />
                                </div>

                                <form action="#" method="post" className="ps-contact-page__form ps-contact-page__form--panel">
                                    <div className="row">
                                        <div className="col-12 col-md-6">
                                            <div className="ps-contact-page__field">
                                                <label htmlFor="contact-name">Your Name <span aria-hidden="true">*</span></label>
                                                <input id="contact-name" className="form-control" type="text" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="ps-contact-page__field">
                                                <label htmlFor="contact-email">Email Address <span aria-hidden="true">*</span></label>
                                                <input id="contact-email" className="form-control" type="email" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="ps-contact-page__field">
                                                <label htmlFor="contact-phone">Phone Number <span aria-hidden="true">*</span></label>
                                                <input id="contact-phone" className="form-control" type="text" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-6">
                                            <div className="ps-contact-page__field">
                                                <label htmlFor="contact-subject">Subject <span aria-hidden="true">*</span></label>
                                                <input id="contact-subject" className="form-control" type="text" placeholder="" />
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="ps-contact-page__field">
                                                <label htmlFor="contact-product">Product Interested In</label>
                                                <select id="contact-product" className="form-control">
                                                    {productOptions.map((option) => (
                                                        <option key={option} value={option}>
                                                            {option}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-12">
                                            <div className="ps-contact-page__field">
                                                <label htmlFor="contact-message">Your Message <span aria-hidden="true">*</span></label>
                                                <textarea id="contact-message" className="form-control" rows="6" placeholder=""></textarea>
                                            </div>
                                        </div>
                                    </div>

                                    <button type="submit" className="ps-contact-page__submit ps-contact-page__submit--panel">
                                        Send Message
                                        <i className="icon-leaf" aria-hidden="true" />
                                    </button>
                                </form>
                            </div>

                            <div className="ps-contact-page__panel ps-contact-page__panel--partner">
                                <div className="ps-contact-page__panel-heading">
                                    <h2 className="ps-contact-page__panel-title">Partner With Nature Way</h2>
                                    <img
                                        className="ps-contact-page__panel-divider"
                                        src="/assets/img/about/about-line.png"
                                        alt=""
                                        aria-hidden="true"
                                    />
                                </div>

                                <div className="ps-contact-page__partner-copy">
                                    <p>Looking to stock Nature Way products?</p>
                                    <p>We welcome</p>
                                </div>

                                <div className="ps-contact-page__partner-grid">
                                    {partnerCategories.map((item) => (
                                        <div className="ps-contact-page__partner-item" key={item.label}>
                                            <span className="ps-contact-page__partner-icon" aria-hidden="true">
                                                <i className={item.iconClass} />
                                            </span>
                                            <span className="ps-contact-page__partner-label">{item.label}</span>
                                        </div>
                                    ))}
                                </div>

                                <button type="button" className="ps-contact-page__submit ps-contact-page__submit--panel">
                                    Become A Partner
                                    <i className="icon-leaf" aria-hidden="true" />
                                </button>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="ps-contact-page__final-row" aria-label="Contact location details">
                    <div className="ps-contact-page__shell">
                        <div className="ps-contact-page__final-grid">
                            <div className="ps-contact-page__final-map">
                                <iframe title="SPT Foods and Cosmetics Private Limited location" src="https://www.google.com/maps?q=NO%204%20Elims%20Nagar%20Pappanchathiram%20Chennai%20Tamil%20Nadu%20600123&amp;output=embed" loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
                            </div>

                            <div className="ps-contact-page__final-card">
                                <div className="ps-contact-page__final-heading">
                                    <h2>Find Us</h2>
                                    <img
                                        className="ps-contact-page__final-divider"
                                        src="/assets/img/about/about-line.png"
                                        alt=""
                                        aria-hidden="true"
                                    />
                                </div>

                                <div className="ps-contact-page__final-address">
                                    <p>No 4, Elims Nagar,</p>
                                    <p>Vedanayagam Road, Pazhanjur,</p>
                                    <p>Pappanchatiram, Chennai - 600123</p>
                                </div>

                                <div className="ps-contact-page__final-contacts">
                                    {contactEmails.map((item) => (
                                        <a className="ps-contact-page__final-contact" href={item.href} key={item.value}>
                                            <span className="ps-contact-page__final-contact-icon" aria-hidden="true">
                                                <i className={item.icon} />
                                            </span>
                                            <span className="ps-contact-page__final-contact-value">{item.value}</span>
                                        </a>
                                    ))}
                                </div>

                                <div className="ps-contact-page__final-actions">
                                    <a className="ps-contact-page__final-btn ps-contact-page__final-btn--primary" href={mapLink} target="_blank" rel="noreferrer">
                                        <i className="icon-location" aria-hidden="true" />
                                        <span>Get Directions</span>
                                    </a>
                                    <a className="ps-contact-page__final-btn ps-contact-page__final-btn--secondary" href={mapLink} target="_blank" rel="noreferrer">
                                        <i className="icon-map" aria-hidden="true" />
                                        <span>View on Map</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}

export default Contactus;
